import { render, staticRenderFns } from "./NavBarAuth.vue?vue&type=template&id=2700a020&scoped=true"
import script from "./NavBarAuth.vue?vue&type=script&lang=js"
export * from "./NavBarAuth.vue?vue&type=script&lang=js"
import style0 from "./NavBarAuth.vue?vue&type=style&index=0&id=2700a020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2700a020",
  null
  
)

export default component.exports